// Tile de indicador del SO (misma gramática que KpiCard, sin sparkline: aquí los
// valores son de una sola corrida, no series).

import type { ReactNode } from 'react';

export function Stat({ icon, label, value, sub, tone = 'violet' }: {
  icon: ReactNode;
  label: string;
  value: ReactNode;
  sub?: ReactNode;
  tone?: 'violet' | 'indigo' | 'blue' | 'magenta' | 'purple';
}) {
  return (
    <div className="orion-card min-w-0 rounded-[20px] border border-border bg-card p-4 sm:p-5">
      <div className="flex items-center gap-2 sm:gap-3">
        <span className={`orion-tone tone-${tone} flex h-9 w-9 shrink-0 items-center justify-center rounded-xl sm:h-10 sm:w-10`} aria-hidden>
          {icon}
        </span>
        <span className="min-w-0 flex-1 text-[13px] font-semibold leading-tight text-foreground sm:text-sm">{label}</span>
      </div>
      <div className="mt-3 break-words text-[19px] font-semibold leading-tight tracking-tight text-foreground tabular-nums sm:text-[26px] sm:leading-none">{value}</div>
      {sub && <div className="mt-1.5 line-clamp-2 text-xs text-muted-foreground">{sub}</div>}
    </div>
  );
}
